// App.tsx - Entry point
import React from 'react';
import QuizApp from './MyQuiz/QuizApp';
import quizConfig from './quiz-config.json';

function MyQuizApp() {
  return <QuizApp config={quizConfig as any} />;
}

export default MyQuizApp;